import { useCallback, useState } from "react";
/**
 * A small hook that can be used for controlling the state of a single Checkbox
 * component.
 *
 * @param defaultChecked Boolean if the input should be checked by default.
 * Changing this value will not update the state after initial render.
 * @param onChange An optional change event handler to also call when the
 * checked state changes.
 * @return a list containing the checked state, a change event handler, and then
 * a manual set checked action.
 */
export default function useChecked(defaultChecked, onChange) {
    var _a = useState(defaultChecked), checked = _a[0], setChecked = _a[1];
    var handleChange = useCallback(function (event) {
        if (onChange) {
            onChange(event);
        }
        setChecked(event.currentTarget.checked);
    }, [onChange]);
    return [checked, handleChange, setChecked];
}
//# sourceMappingURL=useChecked.js.map